import { X, MapPin } from 'lucide-react';
import LocationInput from './LocationInput';
import { useUserLocation } from '../context/LocationContext';

export default function LocationPickerModal() {
  const { showLocationPicker, closeLocationPicker, setLocation, location } = useUserLocation();

  if (!showLocationPicker) return null;

  const handleSelect = (loc) => {
    setLocation(loc);
    closeLocationPicker();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center" data-testid="location-picker-modal">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={closeLocationPicker} />

      {/* Modal */}
      <div className="relative w-full max-w-lg mx-4 mb-0 sm:mb-0 bg-card border border-border rounded-t-2xl sm:rounded-2xl shadow-2xl animate-in slide-in-from-bottom-4 duration-300 max-h-[85vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-border">
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-secondary" />
            <h2 className="text-lg font-bold text-foreground">Set Your Location</h2>
          </div>
          <button
            onClick={closeLocationPicker}
            className="p-1.5 rounded-full hover:bg-muted/50 text-muted-foreground"
            data-testid="location-picker-close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4 overflow-y-auto flex-1">
          <p className="text-sm text-muted-foreground">
            Enter any location worldwide — street, neighborhood, city, or country.
            We'll personalize your feed with local content first.
          </p>

          <LocationInput onSelect={handleSelect} onClose={closeLocationPicker} />

          {/* Current location display */}
          {location && (
            <div className="pt-2 border-t border-border">
              <p className="text-xs text-muted-foreground mb-1">Current location:</p>
              <div className="flex items-center gap-2 text-sm text-foreground">
                <MapPin className="w-3.5 h-3.5 text-secondary" />
                <span>{location.neighborhood}{location.city ? `, ${location.city}` : ''}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
